import React from "react";
import propTypes from 'prop-types';
import { Layout, Typography, Button, Table, Alert, Spin, Space } from "antd";
import MainHeader from "../common/MainHeader";
import ReportLogWoodFilters from "./ReportLogWoodFilters";
import { GET } from "../../utils/HttpClient";
import ReportExportButton from '../../components/common/ReportExportButton';

const { Content } = Layout;
const { Title } = Typography;

function ReportLogWoodDetail(props) {
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [exportParams, setExportParams] = React.useState(null);
  const filterRef = React.useRef();

  const handleFilterSelected = queryString => {
    fetchData(queryString);
    setExportParams(queryString);
  };

  const fetchData = async (params) => {
    if (!params) {
      setErrorMessages("กรุณาเลือกช่วงเวลา");
      return;
    }
    if (!props.url) {
      setErrorMessages("ไม่พบ URL สำหรับดึงข้อมูล");
      return;
    }
    setLoading(true);
    setErrorMessages(null);

    try {
      const response = await GET(`${props.url}?${params}`);
      setData(response.data.map((item, index) => ({ ...item, index: index + 1 })));
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <MainHeader activeItem="MENU_REPORT" />
      <Content style={{ margin: "24px", marginTop: "7em" }}>
        <Title level={2}>{props.title}</Title>
        {errorMessages && (
          <Alert
            message="เกิดข้อผิดพลาด"
            description={errorMessages}
            type="error"
            showIcon
          />
        )}
        <ReportLogWoodFilters
          ref={filterRef}
          onFiltered={handleFilterSelected}
          hideCustomerFilter={props.hideCustomerFilter}
        />
        <div style={{ textAlign: "right", marginBottom: "1em" }}>
          <Space>
            {["pdf", "excel"].map((type) => (
              <ReportExportButton
                key={type}
                url={`${props.exportUrl}${type}/?${exportParams}`}
                type={type}
                title={`${props.title}...`}
                disabled={!exportParams}
              />
            ))}
          </Space>
        </div>

        <Spin spinning={loading} tip="กำลังโหลด...">
          <Table
            dataSource={data}
            columns={props.tableColumns}
            pagination={{
              size: "small",
              showSizeChanger: true,
              position: ["bottomCenter"],
              showTotal: (total) => `Total ${total} rows`,
            }}
            rowKey={(record, index) => index}
            bordered
          />
        </Spin>
      </Content>
    </>
  );
}

export default ReportLogWoodDetail;

ReportLogWoodDetail.propTypes = {
  title: propTypes.string,
  url: propTypes.string,
  tableColumns: propTypes.array,
  exportUrl: propTypes.string,
  hideCustomerFilter: propTypes.bool,
};

ReportLogWoodDetail.defaultProps = {
  title: "Title",
  url: null,
  tableColumns: [],
  exportUrl: "",
  hideCustomerFilter: false,
};
